import CanvaTemplatesRoutes from './routes'

const CanvaTemplates = () => <CanvaTemplatesRoutes />

export default CanvaTemplates
